export const systemImageUploadPolicy = {
  contentTypes: ["image/jpeg", "image/png", "image/webp"],
  maxBytes: 4 * 1024 * 1024,
} as const;

export type SystemImageFileIssue = "too-large" | "unsupported-type";

const systemImageContentTypes = new Set<string>(
  systemImageUploadPolicy.contentTypes,
);

export const systemImageHostname =
  process.env.NEXT_PUBLIC_SYSTEM_BLOB_HOSTNAME?.trim() || "";

export function validateSystemImageFile(file: {
  size: number;
  type: string;
}): SystemImageFileIssue | null {
  if (!systemImageContentTypes.has(file.type)) return "unsupported-type";
  if (file.size > systemImageUploadPolicy.maxBytes) return "too-large";
  return null;
}

export function isConfiguredSystemImageUrl(
  value: string,
  hostname = systemImageHostname,
) {
  try {
    const url = new URL(value);
    return (
      url.protocol === "https:" &&
      Boolean(hostname) &&
      url.hostname === hostname
    );
  } catch {
    return false;
  }
}

export function systemImageUrlsAllowedForSave(
  urls: string[],
  storedUrls: string[],
  hostname = systemImageHostname,
) {
  if (urls.every((url) => isConfiguredSystemImageUrl(url, hostname))) {
    return true;
  }
  if (hostname) return false;

  const knownUrls = new Set(storedUrls);
  return urls.every((url) => knownUrls.has(url));
}
